import { toast as sonnerToast } from 'sonner'

import { ApiError } from '@/api/problem'

/**
 * Ensartede toast-beskeder. Alt der vises til brugeren går herigennem, så tone
 * og formulering er de samme overalt.
 *
 * Ligger adskilt fra `<Toaster>`-komponenten, så begge filer kun eksporterer
 * én slags ting og fast refresh fungerer.
 */
export const toast = {
  success: (message: string, description?: string) =>
    sonnerToast.success(message, { description }),

  info: (message: string, description?: string) => sonnerToast.info(message, { description }),

  warning: (message: string, description?: string) =>
    sonnerToast.warning(message, { description }),

  error: (message: string, description?: string) => sonnerToast.error(message, { description }),

  /**
   * Viser en fejl fra API'et. Valideringsfejl vises ikke som toast – de hører
   * hjemme ved det felt, de handler om, og ville ellers blive vist to gange.
   */
  fromError: (error: unknown, fallback = 'Handlingen kunne ikke gennemføres.') => {
    if (error instanceof ApiError) {
      if (error.isValidationError) {
        return
      }
      sonnerToast.error(error.problem.title ?? fallback, { description: error.userMessage })
      return
    }

    sonnerToast.error(fallback, {
      description: error instanceof Error ? error.message : undefined,
    })
  },

  promise: sonnerToast.promise,
  dismiss: sonnerToast.dismiss,
}
